import React from 'react';
import { MobileStepper, Button } from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

interface ProvisionStepperProps {
  activeStep: number;
  totalSteps: number;
  handleNext: () => void;
  handleBack: () => void;
}

const ProvisionStepper: React.FC<ProvisionStepperProps> = ({ activeStep, totalSteps, handleNext, handleBack }) => (
  <MobileStepper
    variant="progress"
    steps={totalSteps + 1}
    position="static"
    activeStep={activeStep}
    sx={{ maxWidth: 400, height: 50 }}
    nextButton={
      <Button
        size="small"
        onClick={handleNext}
        disabled={activeStep === totalSteps}
      >
        Next
        <KeyboardArrowRight />
      </Button>
    }
    backButton={
      <Button
        size="small"
        onClick={handleBack}
        disabled={activeStep === 0}
      >
        <KeyboardArrowLeft />
        Back
      </Button>
    }
  />
);

export default ProvisionStepper; 